import React, {ReactElement, useEffect, useState} from "react";
import {BORDER_RADIUS, BORDER_RADIUS_LARGE, DIVIDER, PD_MD, PD_SM, PD_XSM, SZ_SM} from "../../shared/dimens";
import {ButtonBase, Grid, Typography} from "@mui/material";
import {ShowcaseItem, ShowcaseItemType} from "../types";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "../../shared/StyledComponents";
import {AddOutlined, FavoriteBorderOutlined, FavoriteOutlined} from "@mui/icons-material";
import {App} from "../App";
import {FullscreenContainer} from "../app-shared/common/Components";
import {Action, UserDisplayName, UserProfilePhoto} from "../../shared/types";
import {ViewItemFragment} from "./ViewItemFragment";
import {ComposerHelper} from "./ComposerHelper";
import {PathProps} from "../../index";
import {ShowcaseItemImage} from "./ShowcaseItemImage";
import Checkbox from "@mui/material/Checkbox";
import {RED} from "../../peppin-shared/colors";
import {LoginHelper} from "../../shared/LoginHelper";

export function ShowcaseItemsView(props: { path: PathProps, items: ShowcaseItem[] }): ReactElement {
  return <Grid container>
    {props.items.map(item => <Grid xs={12} sm={6} md={4}>
      <ShowcaseItemView path={props.path} item={item}/>
    </Grid>)}
  </Grid>;
}

function renderItem(path: PathProps, item: ShowcaseItem): ReactElement | null {
  switch (item.type) {
    case ShowcaseItemType.UPLOAD:
      return <ButtonBase
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
        }}
        onClick={() => ComposerHelper.addItem(path)}>
        <StyledBoxColumn style={{justifyContent: "center", alignItems: "center"}}>
          <AddOutlined/>
          <Typography>
            Upload your first item.
          </Typography>
        </StyledBoxColumn>
      </ButtonBase>;
    case ShowcaseItemType.PLACEHOLDER:
      return null;
    default:
      return <ButtonBase
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
        }}
        onClick={() => App.CONTEXT.showFullscreenDialog(() => <FullscreenContainer
          title={item.title}
          actions={[
            new Action("Close", () => App.CONTEXT.hideDialog()),
          ]}>
          <ViewItemFragment item={item}/>
        </FullscreenContainer>)}>
        <ShowcaseItemImage showcaseItem={item} style={{borderRadius: BORDER_RADIUS}}/>
      </ButtonBase>;
  }
}

export function ShowcaseItemView(props: { path: PathProps, item: ShowcaseItem }): ReactElement {
  const [hover, setHover] = useState<boolean>(false);
  const [favorited, setFavorited] = useState<boolean>(props.item.favorited());
  useEffect(() => {
    props.item.setFavorited(favorited);
  }, [favorited]);
  return <StyledBoxColumn style={{width: "100%", padding: PD_SM, gap: PD_XSM}}>
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        aspectRatio: 1,
        width: "100%",
        position: "relative",
        border: DIVIDER,
        borderRadius: BORDER_RADIUS
      }}>
      {renderItem(props.path, props.item)}
      {hover && props.item.type !== ShowcaseItemType.UPLOAD && props.item.type !== ShowcaseItemType.PLACEHOLDER
        ? <StyledBoxRow style={{
          position: "absolute",
          width: "100%",
          height: "50%",
          padding: PD_MD,
          background: "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0,0,0,0))"
        }}>
          <Typography style={{
            color: "white",
            overflowX: "hidden",
            textWrap: "nowrap",
            textOverflow: "ellipsis"
          }}>{props.item.title}</Typography>
          <StyledSpan/>
        </StyledBoxRow>
        : null}
    </div>
    <StyledBoxRow style={{height: SZ_SM, alignItems: "center"}}>
      {props.item.type !== ShowcaseItemType.UPLOAD && props.item.type !== ShowcaseItemType.PLACEHOLDER
        ? <>
          <img src={UserProfilePhoto(props.item.member.user)}
               style={{width: 24, height: 24, borderRadius: BORDER_RADIUS_LARGE}}/>
          <Typography variant={"body2"} style={{
            overflowX: "hidden",
            textWrap: "nowrap",
            textOverflow: "ellipsis"
          }}>{UserDisplayName(props.item.member.user)}</Typography>
          <StyledSpan/>
          <Checkbox
            checked={favorited}
            icon={<FavoriteBorderOutlined/>}
            checkedIcon={<FavoriteOutlined style={{color: RED}}/>}
            onClick={event => {
              event.stopPropagation();
              LoginHelper.loginAndRun(() => {
                setFavorited(!favorited);
              });
            }}/>
        </>
        : null}
    </StyledBoxRow>
  </StyledBoxColumn>;
}

